if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),

          gallery: this.querySelector('[id^="Slider-Gallery"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          arrownext: this.querySelectorAll(".next-slide-button"),
          arrowprev: this.querySelectorAll(".prev-slide-button"),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.autoplayInterval = 5000; // Interval duration in milliseconds (5 seconds)

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener("click", () => {
                this.stopAutoplay(); 
                this.setActiveMedia(mediaToSwitch.dataset.target, false);
              });
          });
      // Event listeners for arrow buttons
        this.elements.arrownext.forEach((button) => {
          button.addEventListener('click', () => {
            this.stopAutoplay();
            this.moveToNextMedia(); 
          });
        });
  
        this.elements.arrowprev.forEach((button) => {
          button.addEventListener('click', () => {
            this.stopAutoplay();
            this.moveToPreviousMedia();  
          });
        });
  
    // END Event listeners for arrow buttons
      
        // Stop autoplay on click and open modal
        this.elements.gallery.addEventListener("click", (event) => {
          if (event.target.closest("[data-media-id]")) {
            this.stopAutoplay();
            this.openModal(
              event.target.closest("[data-media-id]").dataset.mediaId
            );
          }
        });

        // Stop autoplay on hover
        this.elements.gallery.addEventListener("mouseenter", () => {
          this.stopAutoplay();
        });

        // Restart autoplay on mouse leave (if desired)
        this.elements.gallery.addEventListener("mouseleave", () => {
          this.startAutoplay();
        });
/*
        this.elements.arrownext.forEach((mediaToSwitch) => {
          mediaToSwitch.addEventListener("click", () => {
            this.stopAutoplay(); // Stop autoplay on click

            const currentMedia2 =
              this.elements.viewer.querySelector(".is-active");

            let nextMedia;

            if (this.elements.viewer.querySelector(".is-active")) {
              if (
                this.elements.viewer.querySelector(".is-active")
                  .nextElementSibling === null
              ) {
                nextMedia = this.elements.gallery.querySelectorAll("li")[0];
              } else {
                nextMedia = currentMedia2.nextElementSibling;
              }
            } else {
              // If there is no next element, cycle back to the first element

              nextMedia = this.elements.gallery.querySelectorAll("li")[0];
            }
            // Set active media to the next media item
            this.setActiveMedia(nextMedia.dataset.mediaId, false);
          });
        });
        this.elements.arrowprev.forEach((mediaToSwitch) => {
          mediaToSwitch.addEventListener("click", () => {
            this.stopAutoplay(); // Stop autoplay on click
            const currentMedia2 =
              this.elements.viewer.querySelector(".is-active");

            let nextMedia;

            if (this.elements.viewer.querySelector(".is-active")) {
              if (
                this.elements.viewer.querySelector(".is-active")
                  .previousElementSibling === null
              ) {
                nextMedia =
                  this.elements.gallery.querySelectorAll("li")[
                    this.elements.gallery.querySelectorAll("li").length - 1
                  ];
              } else {
                nextMedia = currentMedia2.previousElementSibling;
              }
            } else {
              // If there is no next element, cycle back to the first element

              nextMedia =
                this.elements.gallery.querySelectorAll("li")[
                  this.elements.gallery.querySelectorAll("li").length - 1
                ];
            }

            this.setActiveMedia(nextMedia.dataset.mediaId, false);
          });
        });
*/
        if (this.dataset.desktopLayout !== "stacked" && this.mql.matches)
          this.removeListSemantic();

        this.startAutoplay();
      }
    // Event listeners for arrow buttons
    // Move to next media
    moveToNextMedia() {
      const currentMedia = this.elements.viewer.querySelector(".is-active");
      let nextMedia = currentMedia?.nextElementSibling || this.elements.viewer.querySelectorAll("[data-media-id]")[0];
      this.setActiveMedia(nextMedia.dataset.mediaId, false);
    }

    // Move to previous media
    moveToPreviousMedia() {
      const currentMedia = this.elements.viewer.querySelector(".is-active");
      let prevMedia = currentMedia?.previousElementSibling || this.elements.viewer.querySelectorAll("[data-media-id]")[this.elements.viewer.querySelectorAll("[data-media-id]").length - 1];
      this.setActiveMedia(prevMedia.dataset.mediaId, false);
    }
    // END Event listeners for arrow buttons
      // Method to start autoplay
      startAutoplay() {
        this.autoplayTimer = setInterval(() => {
          const currentMedia2 =
            this.elements.viewer.querySelector(".is-active");

          let nextMedia;

          if (this.elements.viewer.querySelector(".is-active")) {
            if (
              this.elements.viewer.querySelector(".is-active")
                .nextElementSibling === null
            ) {
              nextMedia = this.elements.gallery.querySelectorAll("li")[0];
            } else {
              nextMedia = currentMedia2.nextElementSibling;
            }
          } else {
            // If there is no next element, cycle back to the first element

            nextMedia = this.elements.gallery.querySelectorAll("li")[0];
          }

          this.setActiveMedia(nextMedia.dataset.mediaId, false);
        }, this.autoplayInterval);
      }

      // Method to stop autoplay
      stopAutoplay() {
        clearInterval(this.autoplayTimer);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

      

        let gallery2 = document
          .querySelector(".media-modal-body")
          .querySelector('[id^="GalleryViewer"]');

        
        if (this.mql.matches) {
        gallery2
          .querySelectorAll("[data-media-id]")

          .forEach((element) => {
            element.classList.remove("is-active");
          });

        const activeMedia2 = gallery2.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        activeMedia2.classList.add("is-active");
      }
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }

      // Method to open the modal

      openModal(mediaId) {
        if (this.mql.matches) { // this.mql == window.matchMedia("(min-width: 750px)")

          
          const modal = document.getElementById("mediaModal");
          const modalBody = modal.querySelector(".media-modal-body");
          const activeMediaModal = this.elements.viewer;

          modalBody.innerHTML = ""; // Clear any existing content
          modalBody.appendChild(activeMediaModal.cloneNode(true)); // Clone and add the active media

          modal.style.display = "flex"; // Show the modal

          // Close modal on click of close button
          modal
            .querySelector(".media-modal-close")
            .addEventListener("click", () => {
              this.closeModal();
            });

          // Close modal on click outside the modal content
          window.addEventListener("click", (event) => {
            if (event.target == modal) {
              this.closeModal();
            }
          });
        }
      }

      // Method to close the modal
      closeModal() {
        const modal = document.getElementById("mediaModal");
        modal.style.display = "none";
      }
    }
  );
}
